<app-upload [userPermission] = "userRole" [businessType]="businessType"></app-upload>
